import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { BankMoviment, ApiGateway, PageOptions } from "cw-backend";
import { SnackBarService } from "cw-utils";

@Injectable()
export class BankMovimentEditProvider implements Resolve<any> {
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    bankMoviment: BankMoviment;

    constructor(public gw: ApiGateway, public snackBar: SnackBarService) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getBankMoviment()]).then(() => {
                resolve(true);
            }, reject);
        });
    }

    getBankMoviment(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data = this.checkLastModifications();
            if (data && data.id == this.routeParams.id) {
                this.bankMoviment = data;
                this.onDataChanged.next(this.bankMoviment);
                resolve(this.bankMoviment);
            } else if (this.routeParams.id === "novo") {
                this.onDataChanged.next(false);
                resolve(false);
            } else {
                this.gw.get("bankMoviment/" + this.routeParams.id).subscribe({
                    next: (res: BankMoviment) => {
                        this.bankMoviment = res;
                        this.onDataChanged.next(this.bankMoviment);
                        resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
            }
        });
    }

    insert(bankMoviment): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("bankMoviment/", bankMoviment).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    transfer(bankMoviment): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("bankMoviment/bank-moviment/", bankMoviment)
                .subscribe({
                    next: (response: HttpResponse<any>) => {
                        resolve(response);
                        this.snackBar.successMessage(response.body.message);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    edit(bankMoviment): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("bankMoviment/", bankMoviment).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    delete(bankMoviment): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete("bankMoviment/" + bankMoviment.id).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    checkLastModifications(): BankMoviment {
        let wasLocked = JSON.parse(localStorage.getItem("session_locked"));
        let data;
        if (wasLocked) {
            data = JSON.parse(localStorage.getItem("last_modification"));
            localStorage.removeItem("session_locked");
        }
        return data;
    }

    getCompanyPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`bankMoviment/company`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getAccountByCompanyId(companyId, pageOptions) {
        return new Promise<any>((resolve, reject) => {
            this.gw
                .post(`bankMoviment/account/company/${companyId}`, pageOptions)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    cancelTranfer(bankMoviment): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete("bankMoviment/cancel/" + bankMoviment.id).subscribe({
                next: (response: HttpResponse<any>) => {
                    resolve(response);
                    this.snackBar.successMessage(response.body.message);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }
}
